import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { initSentry } from '../shared/lib/sentry'
import './lib/i18n'
import '../shared/index.css'
import App from './App'

initSentry('consumer')

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
// ci-incremental-proof A (revert/close)
